module.exports = "https://web-assets-production.autolist.com/_next/static/images/minivan-angled-a046f9e7b8072a2d7b9f42e1a34b2dd1.jpg";